import imagesLoaded from 'imagesloaded';
import Masonry from 'masonry-layout';
import Component from '../Component';

class MasonryGrid extends Component {
  attachEventListeners() {
    imagesLoaded(this.root, () => {
      new Masonry(this.root, {
        itemSelector: '.grid_item',
        percentPosition: true,
        gutter: 15
      });
    });
  }

  componentDidMount() {
    this.attachEventListeners();
  }
}

export default MasonryGrid;
